(() => {
  'use strict';
  // Candidate layouts are available only on an unpublished theme and an explicit preview URL.
  if (window.Shopify?.theme?.role !== 'unpublished') return;
  const variant = new URL(location.href).searchParams.get('wam_cro_preview');
  if (!['collection-compact', 'pdp-compact', 'car-discovery'].includes(variant)) return;
  document.body.dataset.wamExperiment = variant;
  if (variant === 'collection-compact') {
    const grid = document.getElementById('product-grid');
    const section = [...document.querySelectorAll('a[href="/pages/personalized-custom-metal-wall-art?src=collection"]')]
      .map(link => link.closest('.shopify-section'))
      .find(section => section && !section.contains(grid));
    if (grid && section && grid.children.length) {
      const slot = document.createElement('li');
      slot.className = 'column wam-cro-cta-slot';
      slot.dataset.testid = 'wam-collection-preview-cta';
      grid.children[Math.min(3, grid.children.length - 1)].after(slot);
      slot.append(section);
    }
  }
  if (variant === 'car-discovery') {
    const template = document.getElementById('wam-car-discovery-template');
    const grid = document.getElementById('ProductGridContainer');
    if (template && grid) {
      grid.before(template.content.cloneNode(true));
      const form = document.getElementById('WamCarDiscovery');
      const car = form.elements.namedItem('car');
      const model = form.elements.namedItem('model');
      const data = JSON.parse(document.getElementById('wam-car-discovery-data').textContent);
      car.addEventListener('change', () => {
        model.replaceChildren(new Option('All models', ''));
        (data[car.value] || []).forEach(value => model.add(new Option(value, value)));
        model.disabled = !car.value;
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!car.value) { car.focus(); return; }
        const query = [car.value, model.value].filter(Boolean).map(value => '"' + value + '"').join(' ');
        const destination = new URL(form.action, location.origin);
        destination.searchParams.set('q', query);
        destination.searchParams.set('type', 'product');
        location.assign(destination.href);
      });
    }
  }
})();
